// extracted by mini-css-extract-plugin
export default {"downloadButton":"download-report_downloadButton__+6ejs","wrapper":"download-report_wrapper__62KEY","labelWrapper":"download-report_labelWrapper__GDIuZ"};